<template>
  <div id="Site">

      <Header ref="header"/>

      <transition name="fade" appear>
        <main role="main" ref="main" id="Main" class="ViewMain">
          <transition name="fade" mode="out-in">
            <router-view ref="currentView"/>
          </transition>
        </main>
      </transition>

      <Footer ref="footer" />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

import vhCheck from 'vh-check'

import FastClick from 'fastclick'

import Header from '@/components/partials/Header'
import Footer from '@/components/partials/Footer'

export default {
  components: {
    Header,
    Footer
  },
  methods: {
    ...mapActions([
      'setMousePosition',
      'setScrollTop'
    ]),
    onResize(){
      this.$nextTick(() => {
        vhCheck('vh')
      })
    },
    // axeptioCookieConsent(){
    //   void 0 === window._axcb && (window._axcb = [])
    //   window._axcb.push(function(axeptio) {
    //     axeptio.on("cookies:complete", function(choices) {
    //       if(choices.google_analytics) {
    //         // LAUNCH GA ON COOKIE CONSENT
    //         const scriptGTM = document.createElement('script');
    //         scriptGTM.src = 'https://www.googletagmanager.com/gtag/js?id=UA-143011546-1';
    //         scriptGTM.async = true;
    //         scriptGTM.onload = () => {
    //           console.log('GTM Script loaded successfuly');
    //         };
    //         scriptGTM.onerror = () => {
    //           console.log('Error occurred while loading GTM script');
    //         };
    //         document.body.appendChild(scriptGTM);

    //         window.dataLayer = window.dataLayer || [];
    //         function gtag(){dataLayer.push(arguments);}
    //         gtag('js', new Date());

    //         gtag('config', 'UA-143011546-1');
    //       }
    //     })
    //   })
    // }
  },
  created()
  {
  },
  mounted () {

    if ('addEventListener' in document) {
      document.addEventListener('DOMContentLoaded', () => {
        FastClick.attach(document.body)
      }, false)
    }

    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS')
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
    var isIE = navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)
    var isEdge = navigator.userAgent.indexOf('Edge') > 0

    if (isSafari) { document.body.classList.add('safari') }
    if (isFirefox) { document.body.classList.add('firefox') }
    if (isIE) { document.body.classList.add('ie') }
    if (isEdge) { document.body.classList.add('edge') }

    window.addEventListener('resize', this.onResize)
    window.addEventListener('orientationchange', this.onResize)
    this.onResize()

    // ACTIVE MOUSE PARALLAX
    // if (this.$tools.isTouchDevice()) {
    //   window.addEventListener('devicemotion', (e) => {
    //     const accel = e.accelerationIncludingGravity
    //     this.setMousePosition({x: accel.x * 200, y: accel.y * 200})
    //   })
    // }
    // else {
    //   window.addEventListener('mousemove', (e) => {
    //     this.setMousePosition({x: e.clientX, y: e.clientY})
    //   })
    // }

    // ACTIVE SCROLL
    window.addEventListener('scroll', (e) => {
      const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
      this.setScrollTop(scrollTop)
    })

    this.$raf.init()
    this.$scroll.active()

    // this.axeptioCookieConsent()

  }
}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Abril+Fatface|Karla|Raleway&display=swap');
@import './styles/variables'

@import './styles/settings'
@import './styles/global'
@import './styles/animations'

// GENERIC
global-reset()
reset-html5()

.grecaptcha-badge
  display none!important

#Site
  min-height 100vh
  min-height calc(100vh - var(--vh, 0px));
  position relative
  z-index 1
  background-color $beige

body.prerender

  .ViewMain, .Header
    opacity 0!important


main
  transition-delay 0.7s!important
  min-height 100vh

  &.fade-leave-active
    transition-delay 0.3s!important

.safari

  iframe
    object-fit unset!important
</style>
